module.exports = __webpack_public_path__ + "static/media/Teabreaks.dff63833.png";